<template>
  <section class="success">
    <popup-base
      v-show="wantToMakeOffer"
      @clickOnBackground="logState"
    >
      <div class="success-container p-12 text-center rounded">
        <svg-icon
          name="validCircle"
          class="menu_element_icon h-16 "
          original
        />
<!--        <div class="font-bold text-lg mt-2">-->
<!--          Succès!-->
<!--        </div>-->
<!--        <H3 class="p-2">-->
<!--          {{ message }}-->
<!--        </H3>-->
      </div>
    </popup-base>
  </section>
</template>

<script>import PopupBase from '../helper/add/popup-base'
export default {
  name: 'SuccessImageValidate',
  components: { PopupBase },
  props: {
    offer: {
      type: Object,
      default: function () {
        return {}
      }
    },
    wantToMakeOffer: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  methods: {
    logState (answer) {
      this.wantToMakeOffer = answer
      this.$emit('oga', false)
    }
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../assets/style/sass/mixin";
    .success-container {
        background-color: $white;
      width: 50%;
      margin: auto;
    }
    .success-title {
        color: $green
    }
    .submit-buton {
        height: 3rem;
        background-color: $dev-green;
        color: $white;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }
    .popup-arrea {
        background-color: $gray;
    }
    @media screen and (max-width: 700px){ /**androidddddddddddddddddddddddddddddddddddddddddddddddd */
        .success-container{
            margin-left: auto;
            margin-right: auto;
            width: 90%;
            background-color: white;
            padding: 20px 30px 20px 30px;
            border-radius: 6px 6px 6px 6px;
        }
        .iconpp{
            width: 50%;
            height: 70px
        }
        .button{
            font-size: 0.9em
        }
        .role{
            font-size: 0.9em
        }
    }
</style>
